<template>
<div class="page pageNews">
    <headerApp :appLinkShow="appLinkShow" wapTitle="资讯" :spreadID="'0'" :app-link="appLink" :soShow="true" @gotoApp="gotoApp"></headerApp>
    <!-- 头部 -->
    <HomeTabs activeTab="3-0" />

    <!-- 轮播 -->
    <div class="swiper" v-if="bannerList.length">
        <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
            <van-swipe-item v-for="(item, i) in bannerList" :key="i">
                <div @click="jumpAdv(item.wap_url,i)" ><img :src="item.picture" /></div>
            </van-swipe-item>
        </van-swipe>
    </div>
    <div class="advNews">
        <div v-if="threeNewsList.length > 0">
            <template v-for="(item,i) in threeNewsList">
                <div @click="jumpLink(item,i)" :key="i+'advnews'">
                    <dl class="feed1 fix" v-if="item.show_type == 2 && item.pic.length < 3">

                        <dd>
                            <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                            <p>
                                <span class="source"> <span v-if="item.is_exclusive == 1" class="exclusive">独家</span> {{item.resource}}<i>{{item.published_text}}</i></span>
                                <span class="newsTime">

                                    <i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt=""> {{item.view_num}}</i>
                                </span>
                            </p>
                        </dd>
                        <dt>
                            <img :src="item.pic[0]" alt="">
                        </dt>
                    </dl>
                    <dl class="feed2 fix" v-else-if="item.show_type == 2 && item.pic.length > 2">

                        <dd>
                            <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                        </dd>
                        <dt>
                            <ul class="picList fix">
                                <template v-for="(picItem,i) in item.pic">
                                    <li :key="i+'picList'">
                                        <img :src="picItem" alt="">
                                    </li>
                                </template>
                            </ul>

                            <p>
                                <span class="source"> <span v-if="item.is_exclusive == 1" class="exclusive">独家</span> {{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                            </p>
                        </dt>

                    </dl>
                    <dl class="feed2 fix" :key="i" v-else-if="item.show_type == 3">
                        <dd>
                            <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>

                        </dd>
                        <dt>
                            <ul class="picList fix">
                                <template v-for="(picItem,i) in item.pic">
                                    <li :key="i+'picList'">
                                        <img :src="picItem" alt="">
                                    </li>
                                </template>
                            </ul>

                            <p>
                                <span class="source"> <span v-if="item.is_exclusive == 1" class="exclusive">独家</span>{{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                            </p>
                        </dt>
                    </dl>
                    <dl class="feed3 fix" :key="i+'show_type4'" v-else-if="item.show_type == 4">

                        <dt>
                            <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                            <div class="listVideo">
                                <img :src="item.pic[0]" alt="">
                                <span class="icoVideo"></span>
                            </div>
                        </dt>
                        <dd>

                            <p>
                                <span class="source"> <span v-if="item.is_exclusive == 1" class="exclusive">独家</span>{{item.resource}}><i>{{item.published_text}}</i></span><span class="newsTime" ><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                            </p>
                        </dd>

                    </dl>
                    <dl class="feed4 fix" :key="i+'show_type1'" v-else-if="item.show_type == 1">

                        <dd>
                            <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                            <p>
                                <span class="source"><span v-if="item.is_exclusive == 1" class="exclusive">独家</span> {{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                            </p>
                        </dd>

                    </dl>
                    <dl class="feed3 fix" :key="i+'show_type57'" v-else-if="item.show_type == 5 || item.show_type == 7 || item.show_type == 6">
                        <dt>
                            <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                            <div class="listVideo">
                                <img :src="item.pic[0]" alt="">
                                <span v-if="item.show_type != 6" class="icoVideo"></span>
                                <span v-if="item.tag_text&&item.show_type != 6" class="flag">{{item.tag_text}}</span>
                                <span v-if="item.tag_text&&item.show_type == 6" class="flagLive">
                                    <lottie class="liveIconSty" :options="heartOptions" :height="1.1" :width="1.1" />{{item.tag_text}}</span>

                            </div>
                        </dt>
                        <dd>
                            <p>
                                <span class="source"> <span v-if="item.is_exclusive == 1" class="exclusive">独家</span>{{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                            </p>
                        </dd>
                    </dl>
                </div>
            </template>
        </div>

    </div>
    <div class="indexAuc" v-if="videoList.length">
        <h3 class="indexTit"><span class="name">拍行视频</span>
            <router-link :to="{path:'/organVideoList'}" class="more">查看全部</router-link>
        </h3>
        <div class="aucSwiper">
            <div class="swiper-wrapper">
                <dl class="swiper-slide" v-for="(item,i) in videoList" :key="i">
                    <div @click="jumpVideoLink('/videoPlay?type=1&id='+item.id,i)" >
                        <dt>
                            <img :src="item.cover" alt="">
                            <span class="icoVideo"></span>
                            <div class="organName"> <img :src="item.organ_cover" alt="">{{item.organ_name}}</div>
                            <div class="organTitle">{{item.title}}</div>
                        </dt>

                    </div>
                </dl>
            </div>
        </div>
    </div>
    <div class="newsList">
        <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
            <div v-if="newsData.length > 0">
                <template v-for="(item,i) in newsData">
                    <div @click="jumpLink(item,i)" :key="i+'news'">
                        <dl class="feed1 fix" v-if="item.show_type == 2 && item.pic.length < 3">

                            <dd>
                                <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                <p>
                                    <span class="source"><span v-if="item.is_exclusive == 1" class="exclusive">独家</span> {{item.resource}}
                                        <i>{{item.published_text}}</i></span>
                                    <span class="newsTime">

                                        <i v-if="item.view_num > 0"><img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i>
                                    </span>
                                </p>
                            </dd>
                            <dt>
                                <img :src="item.pic[0]" alt="">
                            </dt>
                        </dl>
                        <dl class="feed2 fix" v-else-if="item.show_type == 2 && item.pic.length > 2">

                            <dd>
                                <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                            </dd>
                            <dt>
                                <ul class="picList fix">
                                    <template v-for="(picItem,i) in item.pic">
                                        <li :key="i+'picList'">
                                            <img :src="picItem" alt="">
                                        </li>
                                    </template>
                                </ul>

                                <p>
                                    <span class="source"><span v-if="item.is_exclusive == 1" class="exclusive">独家</span>{{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                                </p>
                            </dt>

                        </dl>
                        <dl class="feed2 fix" :key="i" v-else-if="item.show_type == 3">
                            <dd>
                                <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>

                            </dd>
                            <dt>
                                <ul class="picList fix">
                                    <template v-for="(picItem,i) in item.pic">
                                        <li :key="i+'picList'">
                                            <img :src="picItem" alt="">
                                        </li>
                                    </template>
                                </ul>

                                <p>
                                    <span class="source"><span v-if="item.is_exclusive == 1" class="exclusive">独家</span>{{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                                </p>
                            </dt>
                        </dl>
                        <dl class="feed3 fix" :key="i+'show_type4'" v-else-if="item.show_type == 4">

                            <dt>
                                <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                <div class="listVideo">
                                    <img :src="item.pic[0]" alt="">
                                    <span class="icoVideo"></span>
                                </div>
                            </dt>
                            <dd>

                                <p>
                                    <span class="source"><span v-if="item.is_exclusive == 1" class="exclusive">独家</span>{{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                                </p>
                            </dd>

                        </dl>
                        <dl class="feed4 fix" :key="i+'show_type1'" v-else-if="item.show_type == 1">

                            <dd>
                                <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                <p>
                                    <span class="source"><span v-if="item.is_exclusive == 1" class="exclusive">独家</span>{{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                                </p>
                            </dd>

                        </dl>
                        <dl class="feed3 fix" :key="i+'show_type57'" v-else-if="item.show_type == 5 || item.show_type == 7 || item.show_type == 6">
                            <dt>
                                <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                <div class="listVideo">
                                    <img :src="item.pic[0]" alt="">
                                    <span class="icoVideo"></span>
                                    <span v-if="item.tag_text" class="flag">{{item.tag_text}}</span>
                                </div>
                            </dt>
                            <dd>

                                <p>
                                    <span class="source"><span v-if="item.is_exclusive == 1" class="exclusive">独家</span>{{item.resource}}<i>{{item.published_text}}</i></span><span class="newsTime"><i v-if="item.view_num > 0"> <img class="seeIcon" src="../../assets/img/see_icon.png" alt="">{{item.view_num}}</i></span>
                                </p>
                            </dd>
                        </dl>
                    </div>
                </template>
            </div>
            <emptyPage v-else></emptyPage>
        </van-list>
        <div class="noMore" v-if="noMore">
            <span>我是有底线的</span>
        </div>
    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <watermark v-if="showWater"></watermark>
</div>
</template>

<script>
import emptyPage from "@/components/empty/emptyPage"
import lottie from '@/components/common/lottie'
import {
    hotspot
} from "@/api/new";
// import {
//     mapActions,
//     mapGetters
// } from 'vuex';
import headerApp from "@/components/headerApp";
import DownLoadApp from "@/components/common/downloadApp";
import watermark from "@/components/common/watermark";
import {
    getWXConfig
} from "@/assets/js/weixinShare";
import {
    scMdFunc
} from "@/assets/js/scData";
import HomeTabs from '@/components/HomeTabs.vue'
const liveIcon = require('../../assets/img/live_icon.json')
export default {
    name: "news",
    data() {
        return {
            showWater: false,
            bannerList: [],
            videoList: [],
            heartOptions: {
                animationData: liveIcon,
                loop: true,
                autoplay: true,
            },
            threeNewsList: [],
            appLinkShow: true,
            active: 0,
            page: 1,
            newsData: [],
            loading: false,
            finished: false,
            noMore: false,
            appLink: "/2/8/0",
        }
    },
    created() {
        if (this.$route.query.from && this.$route.query.from == 'cloud') {
            this.showWater = true
        }
    },
    mounted() {
        // if (!this.getIsLoadIng) {
        //     this.getPageNews([0, null, () => {
        //         this.filteData();
        //     }])
        // } else {
        //     // console.log("服务端调用",this.param);
        //     this.filteData();
        // }
        this.getBanner();
        this.filteData();

        // this.getData()
    },
    // asyncData({
    //     store
    // }) {
    //     let params = {
    //         page: 1,
    //         only_meta: 1
    //     }
    //     return store.dispatch("pageNewsV2/getPageNews", [params, null, () => {}]);
    // },
    // computed: {
    //     ...mapGetters({
    //         getIsLoadIng: "pageNewsV2/getIsLoadIng",
    //         getData: "pageNewsV2/getData",
    //     }),
    // },
    methods: {
        // ...mapActions({
        //     getPageNews: "pageNewsV2/getPageNews"
        // }),
        jumpAdv(e,i){
            scMdFunc('allClick', {
                cur_page: '22',
                cur_moudle: '22-1',
                cur_button: '22-1-' + Number(i + 1),
            })
            window.location.href =  e;
        },
        jumpVideoLink(e,i){
            scMdFunc('allClick', {
                cur_page: '22',
                cur_moudle: '22-3',
                cur_button: '22-3-' + Number(i + 1),
            })
            window.location.href =  e;
        },
        jumpLink(e,i) {
            scMdFunc('allClick', {
                cur_page: '22',
                cur_moudle: '22-2',
                cur_button: '22-2-' + Number(i + 1),
            })

            if (e.resource_type == '7') {
                window.location.href = 'https://m-auction.artron.net/live/detail?id=' + e.resource_id + '&special_id=' + e.specail_id;
            } else {
                window.location.href = 'https://m-auction.artron.net/tulu/wap/share/news/?id='+e.resource_id;
            }

        },
        getBanner() {
            hotspot().then((res) => {
                if (res.code == 0) {
                    this.bannerList = res.data.slidepics;
                    this.threeNewsList = res.data.three_news;
                    this.videoList = res.data.video_list;
                }
            });
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0)
        },
        filteData() {
            // let dome = this.$store.state["pageNews"]["data"];
            // document.title = dome.meta ? dome.meta.title : "";
            // let head = document.getElementsByTagName("head");
            // if (!document.querySelector("meta[name=description]")) {
            //     let meta = document.createElement("meta");
            //     meta.name = "description";
            //     meta.content = dome.meta ? dome.meta.description : "";
            //     head[0].appendChild(meta);
            // } else {
            //     document
            //         .querySelector("meta[name=description]")
            //         .setAttribute(
            //             "content",
            //             dome.meta ? dome.meta.description : ""
            //         );
            // }
            document.title = "资讯 - 雅昌拍卖图录"
            window.AFedWxShareData = {
                title: "资讯 - 雅昌拍卖图录APP",
                imgUrl: 'https://components.artron.net/auction/h5img/logo/share_logo.png',
                desc: "雅昌拍卖图录全能助手，拍卖无忧",
                link: window.location.href
            }
            getWXConfig(window.AFedWxShareData);
        },
        onLoad() {
            this.getNewsData();

        },
        getNewsData() {
            let params = {
                page: this.page,
                // pagesize: 20
            }
            // this.loading = true;
            hotspot(params).then((res) => {
                if (res.code == 0) {
                    if (res.data.morePage == 0&& res.data.newsList.length==0) {
                        this.loading = false;
                        this.finished = true;
                    } else if (res.data.newsList.length) {
                        this.newsData = this.newsData.concat(res.data.newsList);
                        this.loading = false;
                        this.page++;
                        if (res.data.morePage == 0) {
                            this.finished = true;
                            this.noMore = true;
                        }
                    }
                }
            });
        },
    },
    components: {
        HomeTabs,
        emptyPage,
        headerApp,
        DownLoadApp,
        watermark,
        lottie
    }
}
</script>

<style lang="scss" scoped>
@import url("../../assets/css/reset.css");
.liveIconSty {
    display: inline-block;
    margin-right: 0.2rem;
    vertical-align: middle;
}

.exclusive{
    color: #2D6BF0;
    margin-right:0.2rem;
}
.seeIcon {
    width: 0.9rem;
    margin-right: 0.1rem;
    vertical-align: top;
}

.pageNews {
    background: #fff;

}

/*拍卖会列表*/
.indexTit {
    padding: .5rem .75rem .75rem;
    line-height: 1.4rem;
    overflow: hidden;
}

.indexTit .name {
    float: left;
    font-size: 1rem;
    color: #27282D;
    font-weight: bold;
}

.indexTit .more {
    float: right;
    background: url("../../assets/img/icon_list_more_light@2x.png") no-repeat right center;
    background-size: .5rem auto;
    background-position-y: 0.35rem;
    font-size: .75rem;
    color: #666;
    padding-right: .9rem;
}

/* 轮播 */
.swiper {
    padding: .17rem .75rem;
}

.swiper /deep/.van-swipe {
    height: 8.05rem;
    width: 100%;
    border-radius: .5rem;
    overflow: hidden;
}

.swiper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.swiper /deep/ .van-swipe__indicators {
    bottom: .5rem;
}

.swiper /deep/ .van-swipe__indicator {
    width: .2rem;
    height: .2rem;
    margin-right: .4rem;
    background: #fff;
    opacity: .5;
    transition: .2s all ease-in-out;
    border-radius: .1rem;
}

.swiper /deep/ .van-swipe__indicator--active {
    opacity: 1;
    width: .8rem;
}

.aucSwiper {
    padding-left: .25rem;
    overflow-x: auto;
    width: 100%;
}

.aucSwiper .organName {
    position: absolute;
    left: 0.5rem;
    top: 0.5rem;
    font-size: 0.7rem;
    color: #fff;

    img {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 1.5rem;
        vertical-align: middle;
        margin-right: 0.2rem;
    }
}

.aucSwiper .organTitle {
    font-size: 0.8rem;
    color: #fff;
    position: absolute;
    left: 0.5rem;
    bottom: 0.5rem;

}

.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
}

.swiper-container-vertical>.swiper-wrapper {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.swiper-slide {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
}

.aucSwiper::-webkit-scrollbar {
    display: none;
}

.aucSwiper .swiper-wrapper {
    display: flex;
}

.aucSwiper .swiper-slide {
    width: 16rem;
    margin-left: .5rem;
}

.aucSwiper a {
    display: block;
}

.aucSwiper dt {
    height: 9.75rem;
    margin-bottom: 0.5rem;
    border-radius: .5rem;
    overflow: hidden;
    position: relative;
    box-shadow: 0px 11px 8px -11px #000;
}

.aucSwiper dt img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.aucSwiper dt .aucStatusBox {
    position: absolute;
    right: 0;
    top: 0;
    border-top-right-radius: 0.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    line-height: 1rem;
    font-size: 0;
    height: 1rem;
}

.aucSwiper dt .aucLive {
    padding: 0 .3rem;
    color: #fff;
    font-size: .6rem;
    display: inline-block;
    line-height: 1rem;
}

.aucSwiper dt .aucLive img {
    height: .5rem;
    width: .45rem;
}

.aucSwiper dt .aucBegin {
    background-color: #000
}

.aucSwiper dt .aucNum {
    padding: 0 .3rem;
    color: #fff;
    font-size: .6rem;
}

.aucSwiper dt .bigFlag {
    position: absolute;
    background: url("../../assets/img/icon_list_HDpic_26@2x.png") no-repeat;
    background-size: 100% 100%;
    width: 1.7rem;
    height: 0.8rem;
    right: 0;
    top: 0;
}

.aucSwiper .title {
    padding: 0;
    line-height: 1.1rem;
    font-size: .8rem;
    color: #27282d;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
}

.aucSwiper .time {
    font-size: .6rem;
    color: #969696;
    line-height: .8rem;
    // padding-left: 1.1rem;
    // background: url("../assets/img/icon_clock.png") no-repeat;
    // background-size: .8rem auto;
}

.aucSwiper .company {
    font-size: .8rem;
    color: #27282d;
    line-height: 1.1rem;
    font-weight: 500;
    margin-top: 0.1rem;

    // padding-left: 1.1rem;
    // background: url("../assets/img/icon_list_other_light@2x.png") no-repeat;
    // background-size: .8rem auto;
}

.aucSwiper .aucFlag {
    font-size: 0;
    margin-top: .5rem;
}

.aucSwiper .aucFlag span {
    display: inline-block;
    white-space: nowrap;
    line-height: .9rem;
    border: .05rem solid #D8D8D8;
    border-radius: .1rem;
    padding: 0 .2rem;
    font-size: .55rem;
    color: #969696;
    margin-right: .3rem;
}

.aucSwiper .icoVideo {
    width: 2rem;
    height: 2rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url("../../assets/img/icon_btn_play.png") no-repeat;
    background-size: cover;
}

.newsList,
.advNews {
    padding: .5rem;

    dl {
        background-color: #fff;
        border-radius: .5rem;
        margin-bottom: .5rem;
        padding: 0.7rem 0.5rem;
        display: flex;
    }

    dl:last-child {
        margin-bottom: 0;
    }

    dd {
        height: 3.75rem;

        margin-right: 0.5rem;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .newsTit {
        line-height: 1.1rem;
        font-size: .8rem;
        color: #27282d;
        overflow: hidden;
        margin-bottom: 0.5rem;
        max-height: 2.2rem;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        flex-direction: column;

        .flag {
            width: 2.5rem;
            height: .8rem;
            margin-right: .15rem;
            font-size: 0;
            vertical-align: .3rem;

            img {
                width: 2.5rem;
                height: .8rem;
                object-fit: cover;
            }
        }

        .title {
            text-align: justify;
        }
    }

    p {
        line-height: 1rem;
        display: flex;
        justify-content: space-between;
        font-size: .5rem;
    }

    .source {
        color: #666;

        img {
            width: 1rem;
            height: 1rem;
            border-radius: 50%;
            object-fit: cover;
            margin-right: .5rem;
            float: left;
        }

        i {
            margin-left: 0.3rem;
        }

    }

    .newsTime {
        color: #969696;

        i:first-child {
            margin-left: 0;
        }

        i {
            margin-left: .5rem;
        }
    }

    .feed1 {
        dd {
            width: calc(100% - 5.4rem);
        }

        dt {
            width: 5.4rem;
            height: 3.75rem;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: .25rem;
                overflow: hidden;
            }
        }

        dt+dd {
            width: 11rem;
        }

        p {
            .source {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }

    .feed2 {
        flex-direction: column;

        dd {
            height: auto;
            margin-bottom: 0.2rem;
        }

        .picList {
            margin-bottom: .5rem;

            li {
                width: 5.4rem;
                height: 3.75rem;
                border-radius: .25rem;
                overflow: hidden;
                float: left;
                margin-right: .25rem;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    overflow: hidden
                }
            }

            li:last-child {
                margin-right: 0;
            }
        }
    }

    .feed3 {
        flex-direction: column;

        dd {
            height: auto;
        }

        .listVideo {
            height: 9.4rem;
            overflow: hidden;
            border-radius: .25rem;
            position: relative;
            margin-bottom: .5rem;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .icoVideo {
                width: 2rem;
                height: 2rem;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                background: url("../../assets/img/icon_btn_play.png") no-repeat;
                background-size: cover;
            }

            .flagLive {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                padding: 0.3rem 0.8rem;
                border-radius: 1rem;
                text-align: center;
                font-size: 0.7rem;
                color: #F64F4F;
                background: rgba(255, 231, 231, 0.5);
            }

            .flag {
                position: absolute;
                right: 0.5rem;
                top: 0.5rem;
                padding: 0.3rem 0.8rem;
                color: #fff;
                text-align: center;
                font-size: 0.5rem;
                background: rgba(132, 132, 132, 0.56);
                border-radius: 1rem;
            }
        }
    }

    .feed4 {
        dd {
            width: 100%;
        }

        p {
            justify-content: space-between;
        }
    }

}
</style>
